import React, { Component } from "react";

import { Link } from "react-router-dom";

class ListHashtags extends Component {
  state = {};
  render() {
    const style = { cursor: "pointer" };
    return (
      //
      <div>
        <Link style={style} to={"/category/" + this.props.category.id}>
          <div style={style} className="list_category_v2">
            #{this.props.category.name}
          </div>
        </Link>
      </div>
    );
  }
}

export default ListHashtags;



// WEBPACK FOOTER //
// ./src/components/list/interface/list_hahstags.jsx